<template>
    <div class="h-full flex flex-col">

            <!-- Header com informações de paginação -->
            <div v-if="servicos.length > 0" class="flex-shrink-0 bg-[#0f3460] border border-[#533483] rounded-lg p-3 mb-3 glass-app">
                <div class="flex justify-between items-center text-sm text-gray-300">
                    <span>
                        Mostrando {{ startItem }} a {{ endItem }} de {{ totalItems }} serviços
                    </span>
                    <button class="dm-btn success" :disabled="aExportar" @click="exportarExcel"
                        title="Exportar todos os serviços filtrados para Excel">
                        <i class="fa-solid fa-file-excel"></i>
                        {{ aExportar ? 'A exportar...' : 'Exportar Excel' }}
                    </button>
                </div>
            </div>

            <!-- Lista de Serviços -->
            <div class="flex-1 overflow-y-auto min-h-0 scrollbar-tema">
                <div class="space-y-2">
                    <div v-if="isLoading" class="text-center text-gray-400 mt-10">
                        <div
                            class="animate-spin w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-2">
                        </div>
                        Carregando serviços...
                    </div>

                    <div v-else-if="servicos.length === 0" class="text-center text-gray-400 mt-10">
                        Aplique os filtros para visualizar os Serviços.
                    </div>

                    <div v-else-if="servicosPaginados.length === 0" class="text-center text-gray-400 mt-10">
                        Nenhum serviço encontrado nesta página.
                    </div>

                    <div v-else>
                        <!-- Cartões de serviços -->
                        <div v-for="(servico, index) in servicosPaginados" :key="`${servico.negocio_id}_${currentPage}`"
                            class="bg-[#0f3460] border border-[#533483] rounded-xl p-3 shadow-lg my-2 glass-app">
                            <div class="flex items-center">
                                <div>
                                    <h3 class="font-bold text-yellow-400">
                                        ({{ servico.negocio_id }}) {{ servico.cliente }} | {{ servico.sub_cliente }}
                                        <i
                                            v-if="servico.sub_cliente_bloqueado"
                                            class="fa-solid fa-lock"
                                            style="color:#ef4444; margin-left:4px"
                                            title="Sub-cliente bloqueado"
                                        ></i>
                                    </h3>
                                    <h5 class="text-gray-50"> {{ servico.local_instalacao }} </h5>
                                    <p class="text-sm text-gray-50">
                                        ({{ servico.qtd_equipamentos }}) |
                                        Equipamento: <span class="text-blue-400">{{ servico.familia }}</span>
                                    </p>
                                </div>
                            </div>
                            <p class="text-sm text-gray-300">{{ servico.morada }}, {{ servico.codigoPostal }}, {{
                                servico.concelho }}</p>

                            <p class="text-gray-400 text-sm">
                                Tipo Intervenção: <span class="text-gray-200">{{ servico.tipo_negocio }}</span><br>
                                Status: <span class="text-gray-200">{{ servico.status }}</span><br>
                                Zona: <span class="text-gray-200">{{ servico.zona }}</span>
                            </p>

                            <p v-if="servico.link_orcamento" class="mt-2 text-gray-400 text-sm">
                                <strong>Orçamento:</strong>
                                <a :href="baseURl + '/api/v1/pdf/orcamentos-token/?token=' + servico.link_orcamento"
                                    target="_blank">
                                    <span class="text-red-400">Ver Orçamento</span>
                                </a>
                            </p>

                            <!-- Footer -->
                            <div class="flex justify-between items-center mt-4">
                                <div class="text-sm">
                                    <p class="text-gray-300">
                                        Data Prevista: <span class="text-gray-100 font-semibold">{{
                                            formatDate(servico.data_inicio) }}</span>
                                    </p>
                                    <p class="text-gray-300">
                                        <!-- {{ servico.valor_sem_iva }} € + IVA {{ (servico.valor_previsto - servico.valor_sem_iva).toFixed(2) }} € = -->
                                        <span class="font-bold text-green-400">{{ servico.valor_previsto }} €</span>
                                    </p>
                                </div>

                                <span v-if="servico.status_ordem_servico == 'atribuido'"
                                    class="bg-blue-600 text-white text-xs font-bold px-2 py-1 rounded-full">
                                    Atribuido a: {{ servico.tecnico }} - {{ new
                                        Date(servico.data_inicio).toLocaleString('pt-PT', {
                                            year: 'numeric', month: '2-digit', day: '2-digit',
                                            hour: '2-digit', minute: '2-digit', hour12: false
                                        }) }}
                                </span>
                            </div>

                            <!-- Botões -->
                            <div class="flex flex-wrap justify-end gap-2 mt-4">
                                <button @click="info_cartao(servico.negocio_id, servico)"
                                    class="bg-blue-600 hover:bg-blue-500 text-white text-xs sm:text-sm px-3 py-1 rounded-lg">
                                    Info
                                </button>
                                <a :href="'./negocio/' + servico.negocio_id" target="_blank">
                                    <button
                                        class="bg-purple-700 hover:bg-purple-600 text-white text-xs sm:text-sm px-3 py-1 rounded-lg">
                                        Negócio
                                    </button>
                                </a>
                                <button @click="abrirAgendar(servico)"
                                    class="bg-green-600 hover:bg-green-500 text-white text-xs sm:text-sm px-3 py-1 rounded-lg"
                                    :disabled="servico.status_ordem_servico == 'atribuido' ? true : false"
                                    :title="servico.status_ordem_servico == 'atribuido' ? 'Agendamento não disponível: serviço já atribuído' : ''"
                                    :style="'cursor:' + (servico.status_ordem_servico == 'atribuido' ? 'not-allowed' : '')" >
                                    Atribuir
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Componente de Paginação -->
            <div v-if="totalPages > 1" class="flex-shrink-0 mt-3 flex flex-col items-center gap-2">
                <span class="text-xs text-gray-400">
                    Página <strong class="text-white">{{ currentPage }}</strong> de <strong class="text-white">{{ totalPages }}</strong>
                </span>
                <Paginate v-model="currentPage" :page-count="totalPages" :page-range="3"
                    :margin-pages="1" :click-handler="handlePageClick" :prev-text="'‹'" :next-text="'›'"
                    :first-last-button="true" :first-button-text="'‹‹'" :last-button-text="'››'"
                    :container-class="'pagination-container'" :page-class="'pagination-page'"
                    :page-link-class="'pagination-link'" :prev-class="'page-prev'" :next-class="'page-next'"
                    :first-class="'pagination-first'" :last-class="'pagination-last'"
                    :active-class="'pagination-active'" :disabled-class="'pagination-disabled'" />
            </div>

        <!-- modal de info -->
        <VueFinalModal v-model="show" class="flex justify-center items-center"
            content-class="flex flex-col gap-3 mx-4 p-6 bg-white dark:bg-gray-900 border dark:border-gray-700 rounded-lg text-gray-900 dark:text-gray-100 w-[1100px] max-w-[90vw] max-h-[85vh]">
            <div class="grid grid-cols-2 gap-5 flex-1 min-h-0">
                <div class="min-h-0 max-h-[55vh] overflow-y-auto pr-1">
                    <h2 class="text-lg font-bold mb-4">Informações Adicionais</h2>

                    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Observações Negócio
                    </label>
                    <textarea rows="4" disabled class="block p-2.5 my-5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300
                            focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600
                            dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">{{ cartoes.negocio_descricao }}
                    </textarea>

                    <!-- Descrição Serviço (negocio.descricao) — desativado a pedido, mantido comentado
                    <hr class="my-4">
                    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Descrição Serviço
                    </label>
                    <textarea v-model="observacoes_planeamento" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300
                            focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600
                            dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">{{ cartoes.negocio_descricao }}
                    </textarea>
                    -->

                    <hr class="my-4">

                    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Observação Interna
                    </label>
                    <textarea v-model="cartoes.observacao_interna" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300
                            focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600
                            dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"></textarea>
                </div>

                <div class="min-h-0 max-h-[55vh] overflow-y-auto pr-1">
                    <h2 class="text-lg font-bold mb-4">Artigos Potenciados</h2>
                    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" class="px-6 py-3">Artigo</th>
                                <th scope="col" class="px-6 py-3">Quantidade</th>
                                <th scope="col" class="px-6 py-3">Desconto</th>
                                <th scope="col" class="px-6 py-3">Preço</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                                v-for="item in cartoes.itens_validacao" :key="item.id">
                                <td class="px-6 py-4 font-medium text-gray-900 dark:text-white">{{ item.equipamento_nome }}
                                </td>
                                <td class="px-6 py-4">{{ item.quantidade }}</td>
                                <td class="px-6 py-4">{{ item.desconto_percentual }}</td>
                                <td class="px-6 py-4">{{ item.preco }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <button @click="gravar_observacoes()" class="self-start px-4 py-2 rounded-lg text-sm bg-green-600 hover:bg-green-500 text-white flex-shrink-0">Guardar</button>
        </VueFinalModal>

        <!-- modal de agendamento -->

        <VueFinalModal v-model="showAgendar" class="flex justify-center items-center"
            content-class="w-[520px] max-w-[92vw] mx-4 p-6 bg-white dark:bg-gray-900 border dark:border-gray-700 rounded-lg text-gray-900 dark:text-gray-100">
            <h2 class="text-lg font-bold mb-4">Agendar Serviço</h2>
            <div class="space-y-4">
                <div>
                    <label class="block text-sm mb-1">Técnico</label>
                    <Multiselect
                        v-model="selectedTecnico"
                        :options="tecnicosParaSelecao"
                        :multiple="false"
                        :searchable="true"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :max-height="250"
                        placeholder="Digite para buscar o técnico..."
                        label="nome"
                        track-by="id"
                        select-label="Presione Enter para selecionar"
                        deselect-label="Presione Enter para remover"
                        selected-label="Selecionado"
                    >
                        <!-- técnico já atribuído que entretanto ficou inativo/desativado: visível mas não selecionável -->
                        <template #option="{ option }">
                            <span>{{ option.nome }}<span v-if="option.$isDisabled"> (inativo)</span></span>
                        </template>
                        <template #noResult>
                            <span>Nenhum técnico encontrado.</span>
                        </template>
                    </Multiselect>
                </div>
                <div v-if="po">
                    <label class="block text-sm mb-1">Cliente trabalha com pedido De Compra (PO)</label>
                    <input type="text" class="w-full text-gray-700" v-model="scheduleForm.pedido_compra" placeholder="">
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

                    <div>
                        <label class="block text-sm mb-1">Início</label>
                        <input type="date" v-model="scheduleForm.inicio"
                            class="w-full bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg p-2 text-sm text-gray-900 dark:text-gray-100" />
                    </div>
                    <div>
                        <label class="block text-sm mb-1">Fim</label>
                        <input type="date" v-model="scheduleForm.fim"
                            class="w-full bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg p-2 text-sm text-gray-900 dark:text-gray-100" />
                    </div>
                </div>
                <p class="text-xs text-gray-400">
                    Todos os serviços são agendados das {{ horaInicioFixa }} às {{ horaFimFixa }}.
                </p>
                <div class="flex justify-end gap-2 pt-2">
                    <button @click="showAgendar = false"
                        class="px-4 py-2 rounded-lg text-sm bg-gray-600 hover:bg-gray-500 text-white">Cancelar</button>
                    <button @click="confirmarAgendamento"
                        class="px-4 py-2 rounded-lg text-sm bg-green-600 hover:bg-green-500 text-white">Confirmar</button>
                </div>
            </div>
        </VueFinalModal>

    </div>
</template>
<script>
import { baseURl } from '@/extraData';
import axios from 'axios';
import Paginate from 'vuejs-paginate-next';

import 'vue-final-modal/style.css'
import { VueFinalModal } from 'vue-final-modal'
import { ca, th } from 'date-fns/locale';
import { toast } from "vue3-toastify";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';
import { descarregarXlsx } from '@/utils/exportarXlsx';

let baseURL = process.env.VUE_APP_URL_BASE;

// Texto numérico ("12.5", "12,5") passa a number, para sair como célula
// numérica no Excel; o que não for um número limpo segue tal como veio.
const paraNumero = (valor) => {
    if (typeof valor === 'number') return valor;
    const texto = String(valor ?? '').trim().replace(',', '.');
    return /^-?\d+(\.\d+)?$/.test(texto) ? parseFloat(texto) : (valor ?? '');
};

// endereco.latitude/longitude são texto em graus decimais e os endereços sem
// coordenadas têm '0' — nesses a célula fica vazia, em vez de apontar para o
// meio do Atlântico.
const paraCoordenada = (valor) => {
    const numero = paraNumero(valor);
    return numero === 0 ? '' : numero;
};

import Cookies from 'js-cookie';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

export default {
    name: "CartoesServicos",
    components: {
        Paginate,
        VueFinalModal,
        Multiselect
    },
    props: {
        dados_filtros: {
            type: Object,
            required: true
        }
    },
    emits: ['refreshCalendario', 'confirm', 'refresh-data'],
    data() {
        return {
            baseURl: baseURl,
            dados_filtros: this.dados_filtros,
            servicos: [],
            isLoading: false,
            aExportar: false,
            show: false,
            po: false,
            observacoes_planeamento: '',
            negocio_id: null,
            ordem_servico_id_info: null,

            // Paginação
            currentPage: 1,
            itemsPerPage: 10, // Valor padrão, será sobrescrito pelos filtros
            totalItems: 0,

            cartoes: {
                observacoes: '',
                observacao_interna: '',
                negocio_descricao: '',
                itens_validacao: []
            },
            showAgendar: false,
            tecnicos: [],
            // Horário fixo de todos os serviços atribuídos por este ecrã.
            // O utilizador escolhe só o dia; a hora não é editável.
            horaInicioFixa: '10:00',
            horaFimFixa: '14:00',
            scheduleForm: {
                servico_id: null,
                tecnico_id: '',
                inicio: '',
                fim: '',
                pedido_compra: '',
            }

        };
    },
    computed: {
        // Só técnicos ativos podem ser escolhidos na atribuição de planeamento
        tecnicosAtivos() {
            return (this.tecnicos || [])
                .filter(tecnico => String(tecnico.status || '').trim().toLowerCase() === 'ativo')
                .sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt', { sensitivity: 'base' }));
        },

        // Técnico já atribuído ao serviço que deixou de estar ativo
        tecnicoAtribuidoInativo() {
            const id = this.scheduleForm.tecnico_id;
            if (!id) return null;
            if (this.tecnicosAtivos.some(tecnico => String(tecnico.id) === String(id))) return null;
            return (this.tecnicos || []).find(tecnico => String(tecnico.id) === String(id)) || null;
        },

        // Opções do Multiselect de técnico: ativos + (se aplicável) o técnico
        // já atribuído que ficou inativo, mostrado mas desabilitado ($isDisabled)
        tecnicosParaSelecao() {
            const opcoes = [...this.tecnicosAtivos];
            if (this.tecnicoAtribuidoInativo) {
                opcoes.unshift({ ...this.tecnicoAtribuidoInativo, $isDisabled: true });
            }
            return opcoes;
        },

        // Getter/setter em forma de objeto para o v-model do Multiselect,
        // sincronizado com scheduleForm.tecnico_id (que guarda apenas o id)
        selectedTecnico: {
            get() {
                const id = this.scheduleForm.tecnico_id;
                if (!id) return null;
                return (this.tecnicos || []).find(tecnico => String(tecnico.id) === String(id)) || null;
            },
            set(tecnico) {
                this.scheduleForm.tecnico_id = tecnico ? tecnico.id : '';
            }
        },

        // Total de páginas
        totalPages() {
            return Math.ceil(this.totalItems / this.itemsPerPage);
        },

        // Serviços da página atual
        servicosPaginados() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.servicos.slice(start, end);
        },

        // Item inicial da página
        startItem() {
            if (this.totalItems === 0) return 0;
            return (this.currentPage - 1) * this.itemsPerPage + 1;
        },

        // Item final da página
        endItem() {
            const end = this.currentPage * this.itemsPerPage;
            return Math.min(end, this.totalItems);
        }
    },
    methods: {
        // Generate UUID compatible with all browsers
        generateUUID() {
            // Fallback for browsers that don't support crypto.randomUUID
            if (typeof crypto !== 'undefined' && crypto.randomUUID) {
                return crypto.randomUUID();
            }

            // Polyfill: Generate UUID v4 manually
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                const r = Math.random() * 16 | 0;
                const v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },

        // Handler para mudança de página
        handlePageClick(pageNumber) {
            this.currentPage = pageNumber;
        },

        // Resetar para primeira página e atualizar records
        resetToFirstPage() {
            this.currentPage = 1;

            // ✅ NOVO: Aplicar a quantidade de records selecionada
            if (this.dados_filtros && this.dados_filtros.records) {
                this.itemsPerPage = parseInt(this.dados_filtros.records);
            }
        },

        // ✅ NOVO: Método para atualizar filtros e aplicar records
        atualizarFiltros(novosFiltros) {
            this.dados_filtros = novosFiltros;

            // Aplicar quantidade de records se fornecida
            if (novosFiltros.records) {
                this.itemsPerPage = parseInt(novosFiltros.records);
            }

            // Buscar serviços com novos filtros
            this.buscarServicos(novosFiltros);
        },

        // Formatar data
        formatDate(dateString) {
            if (!dateString) return 'N/A';

            try {
                return dateString.split('T')[0];
            } catch (error) {
                return 'N/A';
            }
        },

        // Recarregar dados mantendo a página atual
        async refresh() {
            await this.buscarServicos(this.dados_filtros, true);
        },

        // Buscar serviços
        async buscarServicos(filtros, preservarPagina = false) {
            const paginaAntes = this.currentPage;
            this.isLoading = true;

            try {
                const response = await axios.post(
                    process.env.VUE_APP_URL_BASE + '/api/v1/ordemservico/filtro/',
                    filtros
                );

                this.servicos = response.data.data || [];
                this.totalItems = this.servicos.length;

                if (preservarPagina) {
                    const totalPags = Math.ceil(this.totalItems / this.itemsPerPage);
                    this.currentPage = Math.min(paginaAntes, totalPags) || 1;
                } else {
                    this.currentPage = 1;
                }

            } catch (error) {
                console.error('Erro ao buscar serviços:', error);
                this.servicos = [];
                this.totalItems = 0;
            } finally {
                this.isLoading = false;
            }
        },

        // Colunas do Excel: a informação que o cartão mostra, mais as
        // coordenadas da instalação.
        colunasExcel() {
            return [
                { label: 'Negócio', get: (s) => paraNumero(s.negocio_id) },
                { label: 'Cliente', get: (s) => s.cliente },
                { label: 'Sub-cliente', get: (s) => s.sub_cliente },
                { label: 'Sub-cliente Bloqueado', get: (s) => (s.sub_cliente_bloqueado ? 'Sim' : 'Não') },
                { label: 'Local de Instalação', get: (s) => s.local_instalacao },
                { label: 'Qtd. Equipamentos', get: (s) => paraNumero(s.qtd_equipamentos) },
                { label: 'Equipamento', get: (s) => s.familia },
                { label: 'Morada', get: (s) => s.morada },
                { label: 'Código Postal', get: (s) => s.codigoPostal },
                { label: 'Concelho', get: (s) => s.concelho },
                { label: 'Tipo Intervenção', get: (s) => s.tipo_negocio },
                { label: 'Status', get: (s) => s.status },
                { label: 'Zona', get: (s) => s.zona },
                { label: 'Data Prevista', get: (s) => this.formatDate(s.data_inicio) },
                { label: 'Valor Previsto (€)', get: (s) => paraNumero(s.valor_previsto) },
                // Tal como no cartão, o técnico só conta quando o serviço está atribuído
                { label: 'Técnico', get: (s) => (s.status_ordem_servico == 'atribuido' ? s.tecnico : '') },
                {
                    label: 'Orçamento',
                    get: (s) => (s.link_orcamento
                        ? `${this.baseURl}/api/v1/pdf/orcamentos-token/?token=${s.link_orcamento}`
                        : ''),
                },
                { label: 'Latitude', get: (s) => paraCoordenada(s.latitude) },
                { label: 'Longitude', get: (s) => paraCoordenada(s.longitude) },
            ];
        },

        // Exporta todos os serviços do filtro atual (não só a página visível)
        async exportarExcel() {
            if (this.aExportar || this.servicos.length === 0) return;
            this.aExportar = true;
            try {
                const hoje = new Date();
                const carimbo = `${hoje.getFullYear()}${String(hoje.getMonth() + 1).padStart(2, '0')}${String(hoje.getDate()).padStart(2, '0')}`;
                await descarregarXlsx(
                    this.servicos,
                    this.colunasExcel(),
                    `servicos_planeamento_${carimbo}.xlsx`,
                    'Serviços'
                );
                toast(`Exportação concluída (${this.servicos.length} serviços).`, {
                    "theme": "auto",
                    "type": "success",
                    "position": "top-center",
                    "autoClose": 1500,
                });
            } catch (error) {
                console.error('Erro ao exportar serviços:', error);
                toast("Erro ao gerar o Excel.", {
                    "theme": "auto",
                    "type": "error",
                    "position": "top-center",
                    "autoClose": 2000,
                });
            } finally {
                this.aExportar = false;
            }
        },

        info_cartao(negocio_id, servico) {
            // Lógica para mostrar informações do cartão

            axios.get(`${this.baseURl}/api/v1/planeamento/detalhes_servicos/${negocio_id}/${servico.familia_id}/${servico.id}/`)
                .then(response => {
                    const dados = response.data.data || {};
                    // Aqui você pode processar os dados conforme necessário
                    this.cartoes.observacao = dados.observacao || 'NA.';
                    this.cartoes.observacao_interna = dados.observacao_interna || '';
                    this.cartoes.negocio_descricao = dados.negocio_descricao || 'NA.';
                    this.cartoes.itens_validacao = dados.itens_validacao || [];
                    this.observacoes_planeamento = dados.negocio_descricao || '';
                    this.negocio_id = negocio_id;
                    this.ordem_servico_id_info = servico.id;
                    this.show = true;
                })
                .catch(error => {
                    console.error('Erro ao buscar dados do negócio:', error);
                });
            // this.show = true;
        },
        async carregarTecnicos() {
            try {
                const { data } = await axios.get(process.env.VUE_APP_URL_BASE + '/api/v1/utilizador/tecnicos/');
                this.tecnicos = data.data ?? [];
            } catch (error) {
                console.error('Erro ao carregar técnicos:', error);
                this.tecnicos = [];
            }
        },

        abrirAgendar(servico) {
            console.log("Abrindo agendamento para serviço:", servico);
            //this.po = servico.po ? true : false;
            this.scheduleForm = {
                servico_id: servico.id,
                tecnico_id: servico.utilizador_id || '',
                inicio: servico.data_inicio ? servico.data_inicio.slice(0, 10) : '',
                fim: servico.data_fim ? servico.data_fim.slice(0, 10) : '',
                servico: servico,
                pedido_compra: '',
            };
            this.showAgendar = true;
        },
        async confirmarAgendamento() {
            try {
                const { servico_id, tecnico_id, inicio, fim, pedido_compra } = this.scheduleForm;
                if (!pedido_compra && this.po) {
                    toast("Insira o número do Pedido de Compra (PO).", {
                        "theme": "auto",
                        "type": "warning",
                        "position": "top-center",
                        "autoClose": 1000,
                    });
                    return;
                }
                if (!tecnico_id || !inicio || !fim) return;
                if (inicio > fim) {
                    toast("Data de fim tem que superior à data de início!", {
                        "theme": "auto",
                        "type": "warning",
                        "position": "top-center",
                        "autoClose": 1000,
                    });
                    return;
                }
                let servico = this.scheduleForm.servico;

                // Hora fixa. Enviar como texto sem fuso: um objecto Date seria
                // serializado pelo axios em UTC (toISOString) e deslocaria a hora.
                const inicioComHora = `${inicio}T${this.horaInicioFixa}:00`;
                const fimComHora = `${fim}T${this.horaFimFixa}:00`;

                const planeamentoData = {
                    event_id: this.generateUUID(),
                    titulo: servico.familia + ' - ' + servico.cliente + ' ' + servico.local_instalacao + ' ' + servico.morada + ' ' + servico.valor_previsto,
                    inicio: inicioComHora,
                    fim: fimComHora,
                    zona_id: servico.zona_id,
                    servico_id: servico_id,
                    descricao: servico.descricao,
                    utilizador_id: tecnico_id,
                    tecnico_id: tecnico_id,
                    ordemServico_id: servico_id,
                    data: new Date().toISOString(),
                    valor: servico.valor_previsto,
                    status: "atribuido",
                };

                await axios.post(process.env.VUE_APP_URL_BASE + '/api/v1/planeamento/registrar/', planeamentoData)
                    .then(async (response) => {
                        // Atualizar status do serviço
                        await axios.put(process.env.VUE_APP_URL_BASE + `/api/v1/ordemservico/editar/${servico.id}/`, {
                            utilizador_id: tecnico_id,
                            status: "atribuido",
                            pedido_compra: pedido_compra ?? '',
                            data_inicio: inicioComHora,
                            data_fim: fimComHora,
                        }).then(() => {
                            this.$emit("refreshCalendario");
                            this.$emit("refresh-data");
                            toast("Serviço atribuído com sucesso!", {
                                "theme": "auto",
                                "type": "success",
                                "position": "top-center",
                                "autoClose": 1000,
                            });
                        }).catch((error) => {
                            console.error('Erro ao atualizar status do serviço:', error);
                        });
                    });

                this.showAgendar = false;
                // this.buscarServicos(this.dados_filtros);
            } catch (error) {
                 toast(error.response.data.message, {
                                "theme": "auto",
                                "type": "error",
                                "position": "top-center",
                                "autoClose": 1000,
                            });
                            return;
                console.error('Erro ao agendar serviço:', error);
            }
        },
        gravar_observacoes() {
            // Grava a observação interna (ordemServico). A gravação da
            // descrição do serviço (negocio.descricao) foi desativada a
            // pedido — ver o bloco comentado no template — mas o Promise.all
            // fica pronto para reintegrar essa chamada caso volte a ser
            // necessária.
            Promise.all([
                // axios.put(`${this.baseURl}/api/v1/planeamento/atualizar_observacoes/${this.negocio_id}/`, {
                //     observacoes: this.observacoes_planeamento
                // }),
                axios.put(`${this.baseURl}/api/v1/ordemservico/editar/${this.ordem_servico_id_info}/`, {
                    observacao_interna: this.cartoes.observacao_interna
                }),
            ])
                .then(() => {
                    toast("Observações atualizadas com sucesso!", {
                        "theme": "auto",
                        "type": "success",
                        "position": "top-center",
                        "autoClose": 1000,
                    });
                    this.show = false;
                })
                .catch(error => {
                    console.error('Erro ao atualizar observações:', error);
                    toast("Erro ao atualizar observações.", {
                        "theme": "auto",
                        "type": "error",
                        "position": "top-center",
                        "autoClose": 1000,
                    });
                });
        }
    },
    watch: {
        dados_filtros: {
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    // ✅ USAR: Método atualizado que considera records
                    this.atualizarFiltros(newVal);
                }
            },
            deep: true,
            immediate: false
        }
    },
    mounted() {
        // ✅ INICIALIZAR: Aplicar records na montagem do componente
        if (this.dados_filtros && this.dados_filtros.records) {
            this.itemsPerPage = parseInt(this.dados_filtros.records);
        }

        this.carregarTecnicos();
    }
}
</script>
<style scoped>
/* Container da paginação */
.pagination-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
    background: linear-gradient(135deg, #0f3460 0%, #162a4a 100%);
    border: 2px solid #533483;
    border-radius: 0.75rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
    flex-wrap: wrap;
}

/* Botões comuns */
.pagination-page,
.page-prev,
.page-next,
.pagination-first,
.pagination-last {
    min-width: 2.75rem;
    height: 2.75rem;
    flex-shrink: 0;
}

/* Link padrão */
.pagination-link {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: white;
    background: linear-gradient(135deg, #4b5563 0%, #3d4553 100%);
    border: 2px solid #5d6d7d;
    border-radius: 0.5rem;
    transition: all 0.3s ease;
    text-decoration: none;
    cursor: pointer;
    user-select: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Hover padrão */
.pagination-link:hover {
    background: linear-gradient(135deg, #6b7280 0%, #5d6d7d 100%);
    border-color: #8d9da9;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

/* Página ativa */
.pagination-active .pagination-link {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    border-color: #fca5a5 !important;
    color: white !important;
    font-weight: 800 !important;
    font-size: 1.1rem !important;
    box-shadow:
        0 0 0 4px rgba(220, 38, 38, 0.3),
        0 0 20px rgba(220, 38, 38, 0.6),
        inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
    transform: scale(1.15) !important;
    letter-spacing: 0.5px;
}

.pagination-active .pagination-link:hover {
    background: linear-gradient(135deg, #b91c1c 0%, #a01c1c 100%) !important;
    border-color: #f87171 !important;
    transform: scale(1.2) !important;
}

/* Botões desabilitados */
.pagination-disabled .pagination-link {
    background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
    border-color: #4a5568;
    color: #a0aec0;
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
    box-shadow: none;
}

.pagination-disabled .pagination-link:hover {
    transform: none;
    box-shadow: none;
    background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
}

/* Botões especiais (prev, next, first, last) */
.page-prev .pagination-link,
.page-next .pagination-link,
.pagination-first .pagination-link,
.pagination-last .pagination-link {
    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    border-color: #60a5fa;
    font-weight: 700;
    min-width: 3rem;
    font-size: 1rem;
}

.page-prev .pagination-link:hover,
.page-next .pagination-link:hover,
.pagination-first .pagination-link:hover,
.pagination-last .pagination-link:hover {
    background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
    border-color: #93c5fd;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
}

/* Hover para páginas não ativas */
.pagination-page:not(.pagination-active):not(.pagination-disabled):hover .pagination-link {
    background: linear-gradient(135deg, #7b8fa9 0%, #6b7d99 100%);
    border-color: #a0afc9;
    transform: translateY(-2px);
}

/* Cursor pointer */
.pagination-container * {
    cursor: pointer;
    user-select: none;
}

.pagination-disabled,
.pagination-disabled * {
    cursor: not-allowed;
}

/* Responsivo - Tablet */
@media (max-width: 768px) {
    .pagination-container {
        gap: 0.25rem;
        padding: 1rem 0.75rem;
        flex-wrap: wrap;
    }

    .pagination-page,
    .page-prev,
    .page-next,
    .pagination-first,
    .pagination-last {
        min-width: 2.25rem;
        height: 2.25rem;
    }

    .pagination-link {
        padding: 0.25rem;
        font-size: 0.75rem;
        border-radius: 0.375rem;
    }

    .pagination-active .pagination-link {
        transform: scale(1.08) !important;
        font-size: 0.875rem !important;
    }

    .page-prev .pagination-link,
    .page-next .pagination-link,
    .pagination-first .pagination-link,
    .pagination-last .pagination-link {
        min-width: 2.25rem;
        font-size: 0.875rem;
    }
}

/* Responsivo - Mobile */
@media (max-width: 480px) {
    .pagination-container {
        gap: 0.125rem;
        padding: 0.5rem;
    }

    .pagination-page,
    .page-prev,
    .page-next,
    .pagination-first,
    .pagination-last {
        min-width: 2rem;
        height: 2rem;
    }

    .pagination-link {
        font-size: 0.625rem;
        padding: 0.125rem;
    }

    .pagination-active .pagination-link {
        transform: scale(1.05) !important;
        font-size: 0.75rem !important;
    }

    .page-prev .pagination-link,
    .page-next .pagination-link,
    .pagination-first .pagination-link,
    .pagination-last .pagination-link {
        font-size: 0.875rem;
    }
}

/* Scrollbar personalizada */
.scrollbar-tema {
    scrollbar-width: thin;
    scrollbar-color: #4a5568 #2d3748;
}

.scrollbar-tema::-webkit-scrollbar {
    width: 6px;
}

.scrollbar-tema::-webkit-scrollbar-track {
    background: #2d3748;
    border-radius: 3px;
}

.scrollbar-tema::-webkit-scrollbar-thumb {
    background: #4a5568;
    border-radius: 3px;
}

.scrollbar-tema::-webkit-scrollbar-thumb:hover {
    background: #718096;
}

.vfm__content {
    background: white;
    border-radius: 12px;
    max-width: 1100px;
    width: 100%;
    margin: auto;
}

/* Multiselect custom styling (técnico) — mesma paleta dos outros campos
   deste modal (bg-gray-50/dark:bg-gray-700, border-gray-300/dark:border-gray-600,
   text-gray-900/dark:text-gray-100). Aplicado com cores fixas + prefers-color-scheme
   porque o VueFinalModal é teleportado para fora de #app/.glass-app, onde as
   CSS vars do tema (--fundoForm, --text-light, etc.) não estão disponíveis;
   o dark: do Tailwind aqui também segue o prefers-color-scheme do SO (não há
   darkMode: 'class' no tailwind.config.js), por isso replicamos com media query. */
:deep(.multiselect) {
    font-size: 0.875rem;
}

:deep(.multiselect__tags) {
    background-color: #f9fafb;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
    min-height: 42px;
    padding: 0.5rem 2.5rem 0 0.5rem;
}

:deep(.multiselect__input),
:deep(.multiselect__single) {
    background-color: transparent;
    margin-bottom: 0;
    padding: 0;
    font-size: 0.875rem;
    color: #111827;
}

:deep(.multiselect__placeholder) {
    color: #6b7280;
    padding-top: 0;
    margin-bottom: 0;
    font-size: 0.875rem;
}

:deep(.multiselect__content-wrapper) {
    background-color: #f9fafb;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
}

:deep(.multiselect__option) {
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    color: #111827;
}

:deep(.multiselect__option--highlight) {
    background-color: #16a34a;
    color: #ffffff;
}

:deep(.multiselect__option--highlight span) {
    color: #ffffff;
}

:deep(.multiselect__option--selected) {
    background-color: #e5e7eb;
    color: #111827;
    font-weight: 600;
}

@media (prefers-color-scheme: dark) {
    :deep(.multiselect__tags) {
        background-color: #374151;
        border-color: #4b5563;
    }

    :deep(.multiselect__input),
    :deep(.multiselect__single) {
        color: #f3f4f6;
    }

    :deep(.multiselect__input::placeholder) {
        color: #9ca3af;
    }

    :deep(.multiselect__placeholder) {
        color: #9ca3af;
    }

    :deep(.multiselect__content-wrapper) {
        background-color: #374151;
        border-color: #4b5563;
    }

    :deep(.multiselect__option) {
        color: #f3f4f6;
    }

    :deep(.multiselect__option--selected) {
        background-color: #4b5563;
        color: #f9fafb;
    }
}
</style>